import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69d7ce8fa7495700144c960a/fastfoodcrypto/src/app/not-found.tsx");
